import React from "react";
import { Link } from "react-router-dom";
import { scrollTo } from "../../helpers/navigation";

const OffCanvasMenu = () => {
  return (
    <>
      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasWithBackdrop"
      >
        <div className="offcanvas-header d-flex align-items-center mt-4">
          <Link
            to="/"
            className="d-flex align-items-center mb-md-0 text-decoration-none"
          >
            <img
              src="assets/img/logo-color.png"
              alt="logo"
              className="img-fluid ps-2"
            />
          </Link>
          <button
            type="button"
            className="close-btn text-danger"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="far fa-close"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          <ul className="nav col-12 col-md-auto justify-content-center main-menu">
          <li className="nav-item dropdown">
                  <Link
                  data-bs-dismiss="offcanvas"
                    className="nav-link "
                    role="button"
                    onClick={() => scrollTo("inicio")}
                  >
                    Inicio
                  </Link>
                 
                </li>
                <li>
                  <Link 
                  data-bs-dismiss="offcanvas"
                  className="nav-link"  onClick={() => scrollTo("servicios")}>
                    Servicios
                  </Link>
                </li>
                <li>
                  <Link  
                  data-bs-dismiss="offcanvas"
                  className="nav-link"  onClick={() => scrollTo("proceso")}>
                    Proceso
                  </Link>
                </li>
                <li>
                  <Link 
                  data-bs-dismiss="offcanvas"
                  className="nav-link"  onClick={() => scrollTo("equipo")}>
                    Equipo
                  </Link>
                </li>
                <li>
                  <Link 
                  data-bs-dismiss="offcanvas"
                  className="nav-link"  onClick={() => scrollTo("contacto")}>
                    Contacto
                  </Link>
                </li>
          </ul>
          <div className="action-btns mt-4 ps-3">
            <Link
                  data-bs-dismiss="offcanvas"
                  to="/#menu" onClick={() => scrollTo('contacto')} className="btn btn-primary">
              Cuéntenos su idea
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default OffCanvasMenu;
